import { makeVar } from '@apollo/client';

export const initialCheckPointData = {
  orgUnitId: undefined,
  appraisalId: undefined,
  checkPointId: undefined,
  performanceMetrics: [],
  checkPointDocuments: [],
  dataCollectionDate: null,
  selectedPerformanceMetric: null,
  dataCollectedDuringAppraisal: null,
  isDraft: false
};

export const checkPointData = makeVar(initialCheckPointData);

export const checkPointsCache = {
  checkPointData: {
    read: checkPointData
  }
};
